import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';

export default function LocationSection() {
  const { t } = useTranslation();

  const fadeInUp = {
    initial: { opacity: 0, y: 40 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true },
    transition: { duration: 0.6 },
  };

  return (
    <section className="relative py-32 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/f835469a198374fe58a06a17d3b79397.jpg"
          alt="Mojkovac Location"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-black/60"></div>
      </div>

      {/* Content */}
      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
        <motion.h2
          {...fadeInUp}
          className="font-futura font-black text-4xl sm:text-5xl mb-10"
        >
          {t('common:location.title')}
        </motion.h2>

        <motion.div {...fadeInUp} transition={{ delay: 0.2 }} className="mb-6">
          <p className="font-futura font-bold text-2xl sm:text-3xl mb-2">
            {t('common:location.startPoint')}
          </p>
          <p className="font-futura font-bold text-2xl sm:text-3xl">
            {t('common:location.address')}
          </p>
        </motion.div>

        <motion.p
          {...fadeInUp}
          transition={{ delay: 0.3 }}
          className="text-white/80 text-lg mb-8"
        >
          {t('common:location.coordinates')}
        </motion.p>

        <motion.p
          {...fadeInUp}
          transition={{ delay: 0.4 }}
          className="text-white/90 text-lg leading-relaxed max-w-3xl mx-auto"
        >
          {t('common:location.description')}
        </motion.p>
      </div>
    </section>
  );
}